/**
 * @desc this file contains all common functions for application
 * @use code reusability
 */
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants";
var CryptoJS = require("crypto-js");
var defaultErrorMessage = "Something went wrong.";
/**
 * @desc function to decrypt crypto token to jwt token and getting data of logged in user
 */
export function cryptoTokenDecode() {
  let accessToken = localStorage.getItem("accessToken");

  if (!!accessToken) {
    let playload = "";
    let bytes = CryptoJS.AES.decrypt(accessToken, REACT_APP_CRYPTO_SECRET_KEY);
    let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    playload = JSON.parse(atob(decryptedData.split(".")[1]));
    applicationTypeMappings(playload);
    permissionMappings(playload);
    return playload;
  } else {
    return {};
  }
}

export function applicationTypeMappings(playload) {
  // console.log('applicationTypeMappings playload =====>',playload);

  playload.permissionTypes = [];

  if (playload.usertype === "ACCTOWNER") {
    playload.permissionTypes = [
      message.TRANSACTION_CREATOR,
      message.TRANSACTION_EDITOR,
      message.TRANSACTION_VIEWER,
      message.DASHBOARD_VIEWER,
      message.CALENDAR_MANAGER,
      message.CAMPAIGN_MANAGER,
      message.CONTACT_VIEWER,
      message.CONTACT_EDITOR,
      message.CLIENT_VIEWER,
      message.CLIENT_EDITOR,
      message.DOCUMENT_VIEWER,
      message.PROFILE_MANAGER,
      message.view_plan_details,
      message.view_payment_method,
      message.view_billing_details,
      message.manage_master_campaign,
      message.APPONTMENTS_MANAGER,
      message.view_appointments,
      message.manage_appointments,
      message.QUICK_APPONTMENT_MANAGER,
    ];
  } else if (playload.usertype === "ADMIN") {
    playload.permissionTypes = [message.ADMIN_VIEWABLE];
  } else if (playload.usertype === "VENDOR") {
    playload.permissionTypes = [
      //message.TRANSACTION_CREATOR,
      //message.TRANSACTION_EDITOR,
      message.TRANSACTION_VIEWER,
      message.DASHBOARD_VIEWER,
      message.CALENDAR_MANAGER,
      // message.CAMPAIGN_MANAGER,
      // message.CONTACT_VIEWER,
      // message.CONTACT_EDITOR,
      // message.CLIENT_VIEWER,
      // message.CLIENT_EDITOR,
      message.DOCUMENT_VIEWER,
      message.PROFILE_MANAGER,
      message.change_company,
      message.APPONTMENTS_MANAGER,
      playload.roleName === "Artist" ? message.manage_appointments : "",
    ];
  } else if (playload.usertype === "BUYER") {
    playload.permissionTypes = [
      message.TRANSACTION_VIEWER,
      message.DOCUMENT_VIEWER,
      message.PROFILE_MANAGER,
      message.BUYERAGENT_VIEWABLE,
    ];
  } else if (playload.usertype === "BUYERAGENT") {
    playload.permissionTypes = [
      message.TRANSACTION_CREATOR,
      message.TRANSACTION_EDITOR,
      message.TRANSACTION_VIEWER,
      message.DASHBOARD_VIEWER,
      message.CALENDAR_MANAGER,
      message.CAMPAIGN_MANAGER,
      message.CONTACT_VIEWER,
      message.CONTACT_EDITOR,
      message.CLIENT_VIEWER,
      message.CLIENT_EDITOR,
      message.DOCUMENT_VIEWER,
      message.PROFILE_MANAGER,
    ];
  }

  return playload;
}

/**
 * adding permission function
 */
function permissionMappings(playload) {
  let permission = localStorage.getItem("otherInfo");
  if (permission) {
    let bytes = CryptoJS.AES.decrypt(permission, REACT_APP_CRYPTO_SECRET_KEY);
    let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    // console.log("decryptedData", decryptedData);
    // console.log(typeof decryptedData);
    playload.permissionTypes = [
      ...playload.permissionTypes,
      ...decryptedData.split(","),
    ];
  }

  return playload;
}

/**
 * @desc function to get time from minutes
 */
export function getTimeFromMins(mins) {
  if (mins > 24 * 60 || mins < 0) {
    throw new RangeError(
      "Valid input should be greater than or equal to 0 and less than 1440."
    );
  }
  var h = (mins / 60) | 0,
    m = mins % 60 | 0;
  return moment
    .utc()
    .hours(h)
    .minutes(m)
    .format("h:mm A");
}

/**
 * @desc function to get minutes from given date
 */
export function getMinutes(date) {
  return moment(date).hour() * 60 + moment(date).minute();
}

/**
 * @desc function to get minutes from given date with UTC and transaction TZ
 */
export function getUTCdate(date) {
  const originalDate = new Date(date);
  const momentObj = moment(originalDate);
  const utcFormattedDate = momentObj.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
  return utcFormattedDate;
}

/**
 * @desc function to get minutes from given date with UTC and transaction TZ
 */
export function getMinutesWithUTCTZ(date, transTZ) {
  const utcFormattedDate = getUTCdate(date);
  const momentObjutc = moment(utcFormattedDate);
  const convertedDate = momentObjutc
    .tz(transTZ)
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  const timeMin =
    convertedDate.split("T")[1].split(":")[0] * 60 +
    parseInt(convertedDate.split("T")[1].split(":")[1], 10);
  return timeMin;
}

/**
 * @desc function to get time (hh:mm:ss) format from given minutes
 */
export function getTimeFormat(mins) {
  var hours = Math.floor(mins / 60);
  var minutes = mins % 60;
  return (
    (hours < 10 ? "0" : 0) +
    hours +
    ":" +
    (minutes < 10 ? "0" : "") +
    minutes +
    ":00"
  );
}

/**
 * @desc format number as currency 00.00
 */
export function formatNumber(num) {
  if (num !== "" && num !== null && num !== undefined) {
    let newFor = parseFloat(num).toFixed(2);
    return newFor.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}

/**
 * @desc function to formating phone number with format 999-999-9999
 */
export function formatPhoneNumber(num) {
  let mobileNumber = "";
  let dashCheck = num ? num.toString().includes("-") : true;
  if (!dashCheck && num) {
    let getMob = num.toString();
    let a = getMob.slice(0, 3);
    let b = getMob.slice(3, 6);
    let c = getMob.slice(6, 10);
    mobileNumber = a + "-" + b + "-" + c;

    return mobileNumber;
  } else {
    return num;
  }
}

/**
 * @desc change format of number to currency
 */
export function currencyFormat(val) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(val);
}
/**
 * @desc return current date
 */
export function getCurrentDate(separator = "/") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${month}${separator}${date}${separator}${year}`;
}
/**
 * @desc remove '-' (dash) from mobile number format
 * 999-999-9999 to 9999999999
 */
export function removeDashFromMobile(mobileNumber) {
  if (mobileNumber.toString().includes("-")) {
    return mobileNumber.replace(/\-/g, "");
  } else {
    return mobileNumber;
  }
}

/**
 * @desc get today date with format MM/DD/YYYY
 */
export function getToday() {
  let today = new Date();
  let date =
    today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();
  return date;
}

/**
 * @desc function to clean men
 */
export function cleanMentionFieldData(mixedStr) {
  if (!!mixedStr) {
    return mixedStr.replaceAll("{(", "").replaceAll(")}", "");
  }
}

/**** Create Transaction - common functions *****/

export function contigencyFormat(c) {
  let finalInputCont = [];
  for (let i = 0; i < c.length; i++) {
    if (
      c[i].assignee !== "" &&
      c[i].assignee !== undefined &&
      c[i].assignee !== "no"
    ) {
      finalInputCont.push({
        name: c[i].name,
        startDate: new Date(c[i].startDate),
        endDate: new Date(c[i].endDate),
        isParticipant: c[i].isParticipant,
        assignee: c[i].assignee,
      });
    } else {
      finalInputCont.push({
        name: c[i].name,
        startTime: c[i].startTime,
        endTime: c[i].endtime,
        startDate: new Date(c[i].startDate),
        endDate: new Date(c[i].endDate),
        isParticipant: c[i].isParticipant,
      });
    }
  }
  return finalInputCont;
}

export function listingAgentDataFormat(listingAgents) {
  let listingAgentsAr = [];
  if (!!listingAgents) {
    for (let b = 0; b < listingAgents.length; b++) {
      if (!!listingAgents[b]) {
        if (!!listingAgents[b].email && listingAgents[b].email !== "") {
          if (!!listingAgents[b].mobileNumber) {
            listingAgents[b].mobileNumber = removeDashFromMobile(
              listingAgents[b].mobileNumber.toString()
            );
          }
          listingAgentsAr.push(listingAgents[b]);
        }
      }
    }
  }
  return listingAgentsAr;
}

export function closingAgentDataFormat(closingAgents) {
  let closingAgentsAr = [];
  if (!!closingAgents) {
    for (let b = 0; b < closingAgents.length; b++) {
      if (!!closingAgents[b]) {
        if (!!closingAgents[b].email && closingAgents[b].email !== "") {
          if (!!closingAgents[b].mobileNumber) {
            closingAgents[b].mobileNumber = removeDashFromMobile(
              closingAgents[b].mobileNumber.toString()
            );
          }
          closingAgentsAr.push(closingAgents[b]);
        }
      }
    }
  }
  return closingAgentsAr;
}

/**** function to display responses *****/

export function toastMessage(
  type = code.ERROR,
  message = defaultErrorMessage,
  toastConfig = {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: 0,
  }
) {
  switch (type) {
    case code.ERROR:
      toastConfig.toastId = 1;
      toast.error(message, toastConfig);
      break;

    case code.SUCCESS:
      toast.success(message, toastConfig);
      break;
  }
}

export function getMonthName(month) {
  let date = new Date(2000, month, 21);
  let longMonth = date.toLocaleString("en-us", { month: "long" });
  return longMonth;
}

/**** get month with prefix 0 *****/
export function monthWithPrefix(month) {
  return (month < 10 ? "0" : "") + month;
}

/*** convert UTC to specific timezone */
export function convertTZ(date, tzString) {
  return !!date
    ? new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString(
          "en-US",
          {
            timeZone: tzString,
          }
        )
      )
    : "";
}

export function getContingencyData(contingencies, contingencyType, field) {
  let ret = "";
  let found = false;
  for (let i = 0; i < contingencies.length; i++) {
    if (contingencyType === contingencies[i].name) {
      switch (field) {
        case "endDate":
          ret = contingencies[i].endDate;
          found = true;
          break;
        case "startDate":
          ret = contingencies[i].startDate;
          found = true;
          break;
        case "assignee":
          ret = contingencies[i].assignee;
          found = true;
          break;
      }
    }
    if (found) {
      break;
    }
  }
  if (ret === "") {
    ret = false;
  }
  return ret;
}

export function getContingencyAssignee(
  contacts,
  contingencies,
  contingencyType,
  field
) {
  let ret = "";
  let found = false;
  for (let i = 0; i < contingencies.length; i++) {
    for (let j = 0; j < contacts.length; j++) {
      if (
        contingencyType === contingencies[i].name &&
        contacts[j].contactId === contingencies[i].assignee
      ) {
        switch (field) {
          case "fullname":
            ret = contacts[j].firstname + " " + contacts[j].lastname;
            found = true;
            break;
          case "firstname":
            ret = contacts[j].firstname;
            found = true;
            break;
          case "lastname":
            ret = contacts[j].lastname;
            found = true;
            break;
          case "phone":
            ret = contacts[j].mobileNumber;
            found = true;
            break;
          case "email":
            ret = contacts[j].email;
            found = true;
            break;
          case "id":
            ret = contacts[j]._id;
            found = true;
            break;
          case "contactId":
            ret = contacts[j].contactId;
            found = true;
            break;
        }
      }
      if (found) {
        break;
      }
    }
  }
  if (ret === "") {
    ret = false;
  }
  return ret;
}

export function convertTimeToMinutes(timeInHour) {
  let timeParts = timeInHour.split(":");
  return Number(timeParts[0]) * 60 + Number(timeParts[1]);
}

export function checkObjExists(obj) {
  if (obj && Object.keys(obj).length > 0) {
    return true;
  }
  return false;
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function humanize(str) {
  const newStr = str
    .split("_")
    .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(" ");
  return newStr;
}

export function tranformStrToVar(str) {
  let newStr = "";
  if (str) {
    newStr = str.replace(/\s+/g, "-").toLowerCase();
    // if (newStr.match(/[^\-]+/g)) {
    //   newStr = newStr.match(/[^\-]+/g).join("-");
    // }
  }
  return newStr;
}

export function randomCapitalString() {
  const list = "ABCDEFGHIJKLMNPQRSTUVWXYZ";
  var res = "";
  for (var i = 0; i < 4; i++) {
    var rnd = Math.floor(Math.random() * list.length);
    res = res + list.charAt(rnd);
  }
  return res;
}
